import moment from 'moment';
import { DateFilter } from '../../shared/constants';

export const handlePreviousDateRange = (
  from: string,
  to: string,
): {
  from: string;
  to: string;
  durationMs: number;
} => {
  const startDate = moment.utc(from);
  const endDate = moment.utc(to);
  const durationMs = endDate.valueOf() - startDate.valueOf() + 1;

  const fromPreviousPeriod = moment.utc(startDate.valueOf() - durationMs);
  const toPreviousPeriod = moment.utc(endDate.valueOf() - durationMs);

  return {
    from: fromPreviousPeriod.toISOString(),
    to: toPreviousPeriod.toISOString(),
    durationMs,
  };
};

export const handlePreviousDateFormat = (filter: DateFilter): string => {
  const DATE_FILTERS = [
    'week',
    'month',
    'currentWeek',
    'lastWeek',
    'currentMonth',
    'lastMonth',
    'day',
  ];
  const DATE_YEAR_FILTERS = ['currentYear', 'year', 'month'];

  let format = 'YYYY-MM-DD HH:mm';

  if (DATE_FILTERS.includes(filter as string)) {
    format = 'MM-DD';
  } else if (DATE_YEAR_FILTERS.includes(filter as string)) {
    format = 'YYYY-MM';
  }

  return format;
};